import { createRouter, createWebHistory } from 'vue-router';
import Home from './views/Home';
import Config from './views/Config.vue';
import Tracking from './views/Tracking.vue';
import Distribution from './views/Distribution.vue';
const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/home', component: Home, name: 'Home' },
    {
      path: '/distribution',
      component: Distribution,
      name: 'Distribution',
    },
    { path: '/', component: Config, name: 'Config' },
    { path: '/:notFound(.*)', redirect: '/' },
    {
      path: '/tracking',
      name: 'Tracking',
      component: Tracking,
    },
  ],
});

export default router;
